import ApiModel from 'models/api-model';

export default class OCRNavigationModel extends ApiModel({
  data: {
    navigationData: [],
  },
}) {
  get navigationData() {
    return this.data.navigationData;
  }

  filteredPagesHierarchy(term) {
    if (!this.data || !this.data.navigationData) {
      throw new Error('Navigation data is not available');
    }
    return this.data.navigationData.filter(
      (page) =>
        page.sectionName &&
        page.sectionName.toLowerCase().indexOf(term.toLowerCase()) !== -1,
    );
  }

  processResponse(response) {
    return {
      data: {
        navigationData: response.data,
      },
    };
  }
}
